import LegalDocument from "./LegalDocument";

/** Terms 与 Privacy 合并为同一页面。 */
const Privacy = () => <LegalDocument />;

export default Privacy;
